import { observer } from "mobx-react-lite";
import { useRootStore } from "../models/Root";
import { lightningIcon } from "../shared/lightning";
import { IStrike } from "../models/VaisalaAPI";
import { useEffect, useState } from "react";
import { intervalToDuration } from "date-fns";
import { ILightning } from "../models/Layers";
import DivIconMarker from "./DivIconMarker";

interface StrikeProps {
  strike: IStrike;
  selected: boolean;
  set: () => void;
}

const Strike = observer(({ strike }: StrikeProps) => {
  const {
    layers: { lightning },
  } = useRootStore();

  const [date, setDate] = useState(new Date());
  useEffect(() => {
    const interval = setInterval(() => setDate(new Date()), 60000);
    return () => clearInterval(interval);
  }, []);

  const selected = lightning?.selected?.id === strike.id;

  const marker = {
    position: strike.position,
    eventHandlers: {
      click: () => lightning?.set(strike),
    },
  };

  return (
    <DivIconMarker marker={marker} container={{ tagName: "div" }}>
      <span
        style={{
          display: "inline-block",
          padding: "2px",
          ...(selected && {
            outline: "2px solid grey",
            borderRadius: "5px",
          }),
        }}
      >
        {lightningIcon(
          intervalToDuration({ start: strike.local, end: date }),
          "2x"
        )}
      </span>
    </DivIconMarker>
  );
});

interface LightningLayerProps {
  lightning: ILightning;
}
const LightningLayer = ({ lightning }: LightningLayerProps) => {
  const {
    vaisalaApi: { strikes },
  } = useRootStore();

  return (
    <>
      {strikes.map((strike) => (
        <Strike
          key={strike.id}
          strike={strike}
          selected={lightning.selected?.id === strike.id}
          set={() => lightning.set(strike)}
        />
      ))}
    </>
  );
};

export default observer(LightningLayer);
